import actions from "./action";
import { takeEvery, all, call, put, select } from "redux-saga/effects";
import axios from "axios";
import { API_URL, Authorization } from "../../utils/constant";
import { DecryptFunction, EncryptFunction } from "../../utils/cryptoFunction";
import commonActions from "../common/actions";
import { toast } from "react-toastify";


const ProductListSaga = function* () {
  yield all([
    yield takeEvery(actions.GET_PRODUCTS_LIST, ProductList),
    yield takeEvery(
      actions.GET_PRODUCT_LIST_BY_CATEGORY,
      getProductListByCategory
    ),
    yield takeEvery(actions.PRODUCT_FILTER, productFilter),
    yield takeEvery(actions.GET_PRODUCT_DETAILS, getProductDetails),
    yield takeEvery(actions.POST_RATEING_PRODUCTS, rateings),
    yield takeEvery(actions.GET_PRODUCTS_RATEING, GetProductsRateing),
    yield takeEvery(actions.GET_PRODUCT_FILTER, ProductFilterList),
  ]);
};

const ProductList = function* () {
  yield put({
    type: actions.SET_LOADING,
    payload: true,
  });
  try {
    const result = yield call(() => axios.get(`${API_URL}/v1/user/products`));
    yield put({
      type: actions.SET_PRODUCTS_LIST,
      payload: result?.data,
    });
  } catch (error) {
    console.log("Error in catch", error);
  }
  yield put({
    type: actions.SET_LOADING,
    payload: false,
  });
};
const ProductFilterList = function* () {
  yield put({ type: commonActions.PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/v1/admin/products/categories/0`, {
        headers: { Authorization: Authorization },
      })
    );
    const { productFilterList } = yield select(
      (state) => state.ProductListReducer
    );
    yield put({
      type: actions.SET_PRODUCT_FILTER,
      payload: result?.data,
    });
    let finalList = result?.data?.data?.map((val) => {
      return {
        cattle_type: val?.category,
        language: val?.language,
      };
    });
    yield put({
      type: actions.SET_PRODUCT_FILTER_LIST,
      payload: {
        ...productFilterList,
        Category: [...finalList],

      },
    });
  } catch (error) {
    console.log("Error in catch", error);
  }
  yield put({ type: commonActions.PAGE_LOADER, payload: false });
};

const getProductListByCategory = function* (data) {

  let currentLanguage = yield select(
    (state) => state.commonReducer.currentLanguage
  );

  if (!currentLanguage) {
    currentLanguage = "en"
  }

  const { payload } = data;
  yield put({
    type: actions.SET_LOADING,
    payload: true,
  });
  try {
    yield put({ type: actions.SET_PRODUCT_FILTER_LIST, payload: null });
    yield put({
      type: actions.SELECTED_PRODUCT_FILTER,
      payload: { Category: [], Price: null },
    });

    const result = yield call(() =>
      axios.get(`${API_URL}/v1/admin/ext/products/category/${payload}?language_code=${currentLanguage}`, {
        headers: { Authorization: Authorization },
      })
    );
    yield put({
      type: actions.SET_PRODUCT_LIST_BY_CATEGORY,
      payload: result?.data?.data,
    });
    yield put({
      type: actions.SET_ALL_PRODUCT_LIST,
      payload: result?.data?.data,
    });

    const { products, productFilterList } = yield select(
      (state) => state.ProductListReducer
    );
    if (products?.length > 0) {
      let cattleType = [];
      if (payload !== "market") {
        products?.map((val) => {
          if (
            cattleType?.length === 0 ||
            !cattleType?.find(
              (c) =>
                c?.cattle_type?.toLowerCase() ===
                val?.cattle_type?.toLowerCase()
            )
          ) {
            return cattleType.push({
              cattle_type: val?.cattle_type,
              language: val?.language,
            });
          }
        });
      }
      let amountArray = products?.map((val) => {
        return val?.amount;
      });
      yield put({
        type: actions.SET_PRODUCT_FILTER_LIST,
        payload: {
          ...productFilterList,
          PriceFilter: {
            Min: Math.min(...amountArray),
            Max: Math.max(...amountArray),
          },
        },
      });
    }
  } catch (err) {
    console.log(err);
  } finally {
    yield put({
      type: actions.SET_LOADING,
      payload: false,
    });
  }


};

const productFilter = function* (data) {
  const { payload } = data;


  yield put({ type: commonActions.PAGE_LOADER, payload: true });
  try {
    const { allProducts } = yield select((state) => state.ProductListReducer);
    if (allProducts?.length > 0) {
      let FinalArray = [];
      if (payload?.type && payload?.type === "reset") {
        if (payload?.searchedText) {
          let searchFilter = allProducts?.filter((val) => {

            if (
              val?.medicine_name
                ?.toLowerCase()
                ?.includes(payload?.searchedText?.toLowerCase()) ||
              val?.discription
                ?.toLowerCase()
                ?.includes(payload?.searchedText?.toLowerCase())
            ) {
              return val;
            }
          });

          FinalArray = [...searchFilter];
        } else {
          FinalArray = [...allProducts];
        }
      } else {
        if (payload?.Category?.length > 0) {
          let filteredArr = [];
          allProducts?.forEach((val) => {
            if (
              payload?.Category?.find(
                (c) => c?.toLowerCase() === val?.cattle_type?.toLowerCase()
              )
            ) {
              filteredArr.push(val);
            }
          });
          FinalArray = filteredArr.filter((value) => value !== undefined);
        } else {
          FinalArray = [...allProducts];
        }
        if (payload?.Price?.length > 0) {
          FinalArray = FinalArray?.filter((val) => {
            if (
              parseInt(val?.amount) >= parseInt(payload?.Price[0]) &&
              parseInt(val?.amount) <= parseInt(payload?.Price[1])
            ) {
              return val;
            }
          });
        }
      }
      if (
        FinalArray?.length > 0 &&
        payload?.searchedText &&
        payload?.languageCode
      ) {
        const languageCode = payload?.languageCode;
        const searchText = payload?.searchedText?.toLowerCase();


        let searchFilter = FinalArray.filter((item) =>
          item.language.some(
            (lang) =>
              (lang.language_code === languageCode &&
                lang.medicine_name === searchText) ||
              (lang.language_code === languageCode &&
                lang?.discription?.toLowerCase()?.includes(searchText))
          )
        );

        FinalArray = [...searchFilter];
      }
      yield put({
        type: actions.SET_PRODUCT_LIST_BY_CATEGORY,
        payload: FinalArray,
      });
    }
  } catch (err) {
    console.log(err);
  }
  yield put({ type: commonActions.PAGE_LOADER, payload: false });
};



const getProductDetails = function* (data) {

  const { id, language_code } = data?.payload;
  yield put({ type: commonActions.PAGE_LOADER, payload: true });
  try {
    const decryptedId = DecryptFunction(id);
    if (id) {
      const result = yield call(() =>
        axios.get(`${API_URL}/v1/admin/ext/products/${decryptedId}`, {
          headers: { Authorization: Authorization },
        })
      );

      if (result?.data?.code === 200) {
        let details = { ...result?.data?.data[0] };

        const resources =
          details?.language?.find((e) => e?.language_code === language_code)
            ?.resources ?? [];

        if (resources.length > 0) {
          const tempArray = [{ type: "image", url: details?.image_url }];
          for (let i = 0; i < resources.length; i++) {
            const res = resources[i];
            if (
              res?.type?.toLowerCase() === "image" ||
              res?.type?.toLowerCase() === "youtube" ||
              res?.type?.toLowerCase() === "video"
            ) {
              tempArray.push(res);
            }
          }

          details["sliderImages"] = [...tempArray];
        } else {
          details["sliderImages"] = [
            { type: "image", url: details?.image_url },
          ];
        }

        yield put({ type: actions.SET_PRODUCT_DETAILS, payload: details });
      }
    }
  } catch (err) {
    console.log(err);
  } finally {
    yield put({ type: commonActions.PAGE_LOADER, payload: false });
  }
};

const rateings = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/v1/user/ratings`, payload)
    );
    toast.success(result.data.message);
  } catch (error) {
    console.log("Error in catch", error);
    toast.error("Error");
  }
};
const GetProductsRateing = function* (data) {
  const { payload } = data;
  try {
    const id = DecryptFunction(payload);
    if (id) {
      const result = yield call(() =>
        axios.get(`${API_URL}/v1/admin/ext/ratings/product?ref_id=${id}`, {
          headers: { Authorization: Authorization },
        })
      );

      yield put({
        type: actions.SET_PRODUCTS_RATEING,
        payload: result?.data,
      });
    }
  } catch (error) {
    console.log("Error in catch", error);
  }
};

export default ProductListSaga;
